import React, { useCallback } from "react";
import { useResponsive } from "../responsive";
import { Link } from "react-router-dom";
import appHistory from "../../app/appHistory";
import {RouterPaths} from "../../app/appConstants";
import { PUBLIC_URL } from "../../config";
import { LogoComponentStyled } from "./styled/LogoComponentStyled";

interface ILogoProps {
    className?: string,
    height?: React.CSSProperties["height"],  
    isShort?: boolean,
    isDark?: boolean,
    onClick?: () => void ,
}

export const Logo = ({height = "32px", isShort, isDark, className, onClick}: ILogoProps) => {
    return <LogoComponentStyled className={className} onClick={onClick}>
        <img src={`${PUBLIC_URL}/assets/logo/logo${isDark ? '-dark' : ''}${isShort ? '-short' : ''}.svg`} alt="" height={height}/>
    </LogoComponentStyled>
}

interface ILogoComponentProps {
    link?: string,
    onClick?: () => void ,
    isShort?: boolean,
    isDark?: boolean
}

const LogoComponent = ({ link = RouterPaths.main, onClick, isShort, isDark }:ILogoComponentProps) => {
    const {isMediumMaxWidth, isSmallMaxWidth} = useResponsive();
    const heightNum = isSmallMaxWidth
            ? 24
            : isMediumMaxWidth
                    ? 28
                    : 32;
    const handleClick = useCallback(() => {
        appHistory.push(RouterPaths.main);
        if (onClick) onClick();
    }, [onClick]);
    return (
            <Link to={link} onClick={handleClick}>
                <Logo height={`${heightNum}px`} isShort={isShort ?? isSmallMaxWidth} isDark={isDark}/>
            </Link>
    );
}

export default LogoComponent;